import { Controller } from "@hotwired/stimulus"

// Shows an inline confirmation modal before a non-GET request goes out.
//
// The trigger is a real form (button_to), so the action still works with JavaScript disabled — the
// request simply leaves without asking for confirmation. With JS, the submit is intercepted, the
// modal opens, and the very same form is submitted once the user confirms. That is why the verb and
// the URL are never duplicated in data attributes: the form already carries them.
//
// Usage: wrap trigger + modal in <div data-controller="confirm-action">;
// trigger: button_to ..., form: { data: { action: "submit->confirm-action#open" } };
// modal overlay: data-confirm-action-target="overlay";
// modal confirm button: data-action="click->confirm-action#confirm".
export default class extends Controller {
  static targets = ["overlay"]

  open(event) {
    // Second pass, fired by requestSubmit after the user confirmed: let it through.
    if (this.submitting) return
    if (!this.hasOverlayTarget) return

    event.preventDefault()
    this.form = event.currentTarget
    this.overlayTarget.classList.remove("hidden")
    // Focus the overlay so its keydown.esc binding receives the key.
    this.overlayTarget.focus()
  }

  close(event) {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    if (!this.hasOverlayTarget) return
    this.overlayTarget.classList.add("hidden")
  }

  overlayClick(event) {
    if (event.target === this.overlayTarget) this.close(event)
  }

  stopPropagation(event) {
    if (event) event.stopPropagation()
  }

  confirm(event) {
    if (event) event.preventDefault()
    if (!this.form) return

    this.submitting = true
    this.overlayTarget.classList.add("hidden")
    this.form.requestSubmit()
  }
}
